import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
			'hd-base-icon-button',
			`hd-base-icon-button__${_ctx.modifier}`
		]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.callbackFn && _ctx.callbackFn(...args)))
  }, [
    _createVNode(_component_base_image_svg, { source: _ctx.iconSource }, null, 8, ["source"]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}